import script from "./PhaseTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./PhaseTitle.vue?vue&type=script&setup=true&lang=js"

import "./PhaseTitle.vue?vue&type=style&index=0&id=d3bb5840&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3bb5840"]])

export default __exports__